import { useCallback } from 'react';
import { EditorView } from 'prosemirror-view';

import { MentionNodeAttrs } from '../../nodes/Mention/const';
import { closeDialog } from './utils';

export const useMenuItemClick = (view?: EditorView, match?: string) => {
  return useCallback(
    (attrs: MentionNodeAttrs) => {
      if (view) {
        closeDialog(view.state, view.dispatch);

        const charactersToReplace = (match?.length || 0) + 1;
        const position = view.state.selection.$anchor.pos;
        const mentionNode = view.state.schema.nodes.mention.create(attrs);
        // add a text node give that extra space after the mention
        const textNode = view.state.schema.text(' ');
        const tr = view.state.tr.replaceWith(position - charactersToReplace, position, [
          mentionNode,
          textNode,
        ]);

        view.dispatch(tr);
        view.focus();
      }
    },
    [view, match],
  );
};
